(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesController', TabDeviceReleasesController);

    TabDeviceReleasesController.$inject = ['$state', 'TabDeviceReleases', 'TabObjectTypes','ParseLinks', 'AlertService', 'pagingParams', 'TabDevices', 'paginationConstants'];

    function TabDeviceReleasesController ($state, TabDeviceReleases, TabObjectTypes, ParseLinks, AlertService, pagingParams, TabDevices, paginationConstants) {
        var vm = this;
        vm.tabDeviceReleases = [];
        vm.tabDeviceReleasesInactive = [];
        vm.predicates = pagingParams.predicates;
        //vm.page = 0;
        vm.loadPage = loadPage;
        vm.currentState = "tab-device-releases";
        vm.charToSearch = pagingParams.search;
        vm.objectType = {};
        vm.objectType.id = pagingParams.objectType;
        vm.device = {};
        vm.device.id = pagingParams.device;
        vm.loadFilters = loadFilters;
        vm.loadFilters();
        vm.transition = transition;
        vm.selectFilter = false;

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;     //Pagination da aggiungere sopra ['']
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function loadFilters() {
            TabObjectTypes.query({
                page: 0,
                size: 1000
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.objectTypes = data;
                vm.objectTypes.unshift({
                    id: -1,
                    objectTypeName: "All"
                });
                vm.objectTypes.forEach(function (value) {
                    if (value.id == pagingParams.objectType) {
                        vm.objectType = value;
                    }
                });
            }

            TabDevices.query({
                page: 0,
                size: 1000
            }, onSuccessDevice, onError);

            function onSuccessDevice(data) {
                vm.devices = data;
                vm.devices.unshift({
                    id: -1,
                    deviceName: 'All'
                });
                vm.devices.forEach(function (value) {
                    if (value.id == pagingParams.device) {
                        vm.device = value;
                    }
                });
            }

            function onError() {
            }
        }

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function(notify) {
            var page = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch
            };
            var ch = {ch: vm.charToSearch, objectType: vm.objectType.id, device: vm.device.id};

            if(vm.selectFilter && vm.objectType.id != -1){
                TabDeviceReleases.search(page, ch, onSuccess, onError);
            } else {
                if(vm.device.id == -1){
                    TabDeviceReleases.getPage(page, ch, onSuccess, onError);
                } else {
                    TabDeviceReleases.filterTypePage({id: vm.device.id, query: vm.charToSearch}, onSuccess, onError);
                }
            }

            function onSuccess(data, headers) {
                vm.selectFilter = false;
                vm.tabDeviceReleases = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    vm.tabDeviceReleases.push(data[i]);
                    vm.loadInactive(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last'])
                    vm.loadPage();
                // transition (notify);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function() {
            vm.page = 0;
            vm.tabDeviceReleases = [];
            vm.loadAll();
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        vm.loadAll();

        vm.loadInactive = function(tabDevice) {
            TabDeviceReleases.load({name: tabDevice.deviceReleaseName, idShowed : tabDevice.id}, null, onSuccess, onError);
            function onSuccess(data) {
                vm.tabDeviceReleasesInactive[tabDevice.deviceReleaseName] = [];
                vm.tabDeviceReleasesInactive[tabDevice.deviceReleaseName] = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.charToSearch,
                objectType: vm.objectType.id,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                device: vm.device.id
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            vm.tabDeviceReleases = [];
            pagingParams.page = 1;
            vm.selectFilter = true;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();

    }
})();
